import { useQuery } from '@tanstack/react-query';

import regularStatus from '../../../regular/status';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function useMtPortfolioByCode(stockCode) {
  const { cb, key } = fetch();

  const { isMtActive } = regularStatus.useAccountStatus();

  const enabled =
    isMtActive && // Do not call when user does not have MT account
    !!stockCode; // Do not call without stock code

  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled,
    staleTime: 2500,
  });

  // Fetch all MT portfolio
  // Then filter data based on given stockCode
  const _data = data?.portfolio?.find((v) => v.stock === stockCode) || null;

  /**
   * Number of lots owned by the user that can be put in a new Sell order.
   * Lots currently being locked on other features cannot be sold.
   *
   * - lot              : lot owned by user
   * - sellot           : lot currently being held on an open sell order
   * - freeze_asset_lot : lot currently being held due to TP/SL
   * */
  const mtAvailableLot =
    (_data?.lot || 0) - ((_data?.selllot || 0) + (_data?.freeze_asset_lot || 0));

  return { data: _data, isSuccess, refetch, mtAvailableLot };
}

export default useMtPortfolioByCode;
